import {
  Checkbox as AriaCheckbox,
  CheckboxProps as AriaCheckBoxProps,
} from 'react-aria-components';
import { cn } from '~/lib/utils';
import Icon from './Icon';

export interface CheckBoxProps extends AriaCheckBoxProps {
  className?: string;
  label?: string;
}

function Checkbox({ label, className, ...props }: CheckBoxProps) {
  return (
    <AriaCheckbox className={cn('flex items-start gap-3 group', className)} {...props}>
      {({ isSelected }) => (
        <>
          <div
            className={cn(
              'flex items-center justify-center rounded-md border-1 transition-all duration-200 w-6 h-6 shrink-0',
              isSelected
                ? 'bg-brand-gradient border-transparent'
                : 'border-input-border bg-input-background',
            )}
          >
            {isSelected && <Icon name="checkMark" className="text-[16px]" />}
          </div>
          {label && (
            <div className="text-[13px] leading-[1.8] font-medium text-input-label/80">{label}</div>
          )}
        </>
      )}
    </AriaCheckbox>
  );
}

export default Checkbox;
